import React, {useContext, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';

import {ContextAuth} from '../../../common/context/context-auth';

import ModalCustomerClub from '../../modal/CustomerClub/CustomerClub';

import {Container, Row, Col, Button} from 'react-bootstrap';

import {ReactComponent as ImgCustomerClub} from '../../../asset/img/icon/customer-club.svg';

import * as IconFi from 'react-icons/fi';

import './CustomerClub.scss';
import GlobalConst from "../../../common/global-const";

const CustomerClub = () => {
    const location = useLocation();
    const auth = useContext(ContextAuth)

    // -----------------------------------------------------------------------------------------------------------------

    const [modalCustomerClubShow, setModalCustomerClubShow] = useState(false);

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            <div id="pageCustomerClub">
                <section id="banner" className="position-relative mb-3 mb-md-4 mb-xl-5">
                    <div className="bg-elevate-1">
                        {/*<figure className="d-block mx-auto mb-0 filter-warm">*/}
                        <figure className="d-block mx-auto mb-0">
                            {/*<span className="filter-level"/>*/}
                            <img src={auth?.params?.micamallCustomerClubImage ? `${GlobalConst.cdn}${auth?.params?.micamallCustomerClubImage}` : "../img/page/customer-club/banner-sm.jpg"} alt="" className="h-100 w-100 object-fit-cover"/>
                            <span className="filter-gradient"/>
                        </figure>
                    </div>
                    <div className="position-absolute start-0 bottom-0 end-0">
                        <Container fluid="lg">
                            <div className="p-4">
                                <Row className="g-3 g-md-0 justify-content-between">
                                    <Col md="auto" className="d-flex align-items-center">
                                        <h1 className="fw-bold mb-0 mb-md-n2 text-primary text-truncate mw-100">{auth.routes.find(({alias}) => `/${alias}` === location.pathname).title}</h1>
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </div>
                </section>
                <Container id="list" fluid="lg">
                    <Row>
                        <Col xs={12} className="d-grid">
                            {/*<div className="bg-secondary p-4 text-accent-3 text-center fs-4"><ImgCustomerClub className="me-2"/>فهرست باشگاه مشتریان</div>*/}
                            <Button id="btnCustomerClub" variant="secondary" className="text-accent-3 fs-4 p-4" onClick={() => setModalCustomerClubShow(true)}><ImgCustomerClub width={32} height={32} fill="var(--bs-accent-3)" strokeWidth="0" className="me-2"/>فهرست باشگاه مشتریان</Button>
                        </Col>
                    </Row>
                </Container>
                <Container fluid="lg" className="mt-4">
                    <Row>
                        <Col xs={12}>
                            <h1 className="fs-3 fw-normal">تاریخچه باشگاه مشتریان میکامال</h1>
                            <p>
                                باشگاه مشتریان میکامال در سال 1402 راه‌اندازی شد. این باشگاه به‌ پاس قدردانی از اعتماد مشتریان برای نخستین‌بار در سطح کشور، عضوپذیری نامحدود را آغاز کرد. بسترهای متنوع باشگاه مشتریانِ میکامال این امکان را فراهم ساخته که همۀ مشتریان با هر میزان خرید از این مرکز تفریح و خرید، عضو آن شوند و شانس برنده‌شدن در قرعه‌کشی‌های بزرگِ روزانه و فصلی را داشته باشند.
                                <br/>
                                هدف باشگاه مشتریان میکامال ارائه اعتبارات و امتیازات ویژه به اعضاء باشگاه است تا از ظرفیت‌های خرید از بهترین برندهای روز دنیا، کافه‌ها و رستوران‌ها، فضاهای تفریحی همچون تونل‌باد، تله‌کابین، آیس‌رینک، شهربازی، پردیس سینمایی، بولینگ، بیلیارد و دیگر فضاهای تفریحی میکامال و جزیرۀ کیش بهره‌مند شوند.
                            </p>
                            <h6>شیوۀ عضویت مشتری:</h6>
                            {
                                auth.user ? (
                                    <>
                                        <p className="mb-1 text-success">شما در  باشگاه مشتریان عضو هستید.</p>
                                        <div className="mb-4 pt-2">
                                            <Button as={Link} to="/account/customer-club" variant="outline-success">مشاهده اطلاعات شما در باشگاه مشتریان<IconFi.FiArrowLeft size={24} className="sw-1 ms-2"/></Button>
                                        </div>
                                    </>
                                ) : (
                                    <p>
                                        مراجعان با مراجعه به میزهای اطلاعات میکامال تنها با ثبت شماره همراه و شماره کارت بانکی خود برای همیشه عضو باشگاه می‌شوند و پس از دریافت کارت باشگاه می‌توانند بلافاصله از فروشگاه‌های عضو باشگاه خرید کرده و از همۀ امتیازها، اعتبارها و خدمات باشگاه بهره‌مند شوند. همچنین، مشتریان به‌محضِ خرید، از طریق پیامک‌های ارسالیِ باشگاه، میزان و موجودی کوین و اعتبارِ دریافتی خود را مشاهده می‌کنند. هر مشتری پس از عضویت پروفایل اختصاصی خود را در تارنمای میکامال خواهد داشت، که تمامی گزارش‌های خرید و امتیازهایش قابل مشاهده است.
                                    </p>
                                )
                            }
                            <h6>میکاکوین Mica Coin چیست؟</h6>
                            <p>
                                میکاکوین (Mica Coin) یک واحد امتیازدهی است.
                                <br/>
                                با خرید از همۀ فروشگاه‌های عضو باشگاه، میکاکوین به مشتری اعطا می‌شود.
                                <br/>
                                اعضای باشگاه با هر 100 هزار تومان خرید از فروشگاه‌های عضو باشگاه، بین 5 تا 20 میکاکوین امتیاز دریافت می‌کنند.
                                <br/>
                                اعضای باشگاه با مصرف امتیازات میکاکوین می‌تواند از تخفیف‌های 10 تا 90 درصدی تفریحات در میکامال و جزیرۀ کیش و خدمات ویژه مال استفاده کنند.
                                <br/>
                                اعضای باشگاه می‌توانند امتیازات خود را برای شرکت در قرعه‌کشی‌های روزانه و ویژه مصرف نمایند.
                                <br/>
                                اعضای باشگاه می توانند امتیازات خود را برای ارتقا سطح کارت باشگاه به نقره ای، طلایی و پلاتینیوم مصرف نمایند.
                            </p>
                            <h6>فروشگاه های Mica Credit</h6>
                            <p>
                                (دریافت اعتبار خرید مجدد به مدت نامحدود)
                                <br/>
                                اعطاء امتیاز بین 5 تا 20 میکاکوین با هر 100 هزار تومان خرید
                            </p>
                            <h6>فروشگاه های Mica Cash</h6>
                            <p>
                                (دریافت اعتبار خرید مجدد و اعتبار نقدی به مدت نامحدود)
                                <br/>
                                اعطاء امتیاز بین 10 تا 25 میکاکوین با هر 100 هزار تومان خرید
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ModalCustomerClub show={modalCustomerClubShow} onHide={() => setModalCustomerClubShow(false)}/>
        </>
    )
}

export default CustomerClub;